import { useState, useEffect, useRef } from "react";

import axios from "axios";

import Upload from "../../Assests/Category/upload.svg";
import "../../Styles/CategoryPage.css";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";

import {
  BASE_URL,
  BUCKET_BASE_URL,
  EDIT_CATOGRY_DATA,
  LIST_ALL_Defaults,
  UPDATE_CATOGRY,
} from "../../Constants/Config";

import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { deleteCategorybanner } from "../../Redux/features/Categories/categoriesSlice";
import DeleteIcon from "../../Assests/Category/deleteIcon.svg";
import { ToastifyAlert } from "../../CommonComponents/ToastifyAlert";
import { useNavigate } from "react-router-dom";
import { useAuthDetails } from "../../Common/cookiesHelper";
import DeleteModal from "../../reuseableComponents/DeleteModal";
import AlertModal from "../../reuseableComponents/AlertModal";
import CircularProgress from "@mui/material/CircularProgress";
import PasswordShow from "../../Common/passwordShow";
import SwitchToBackButton from "../../reuseableComponents/SwitchToBackButton";
import { Grid } from "@mui/material";
import { PERMISSIONS } from "../../Constants/permission";
import { useSelector } from "react-redux";
import { fetchQCList } from "../../Redux/features/QCList/qcListSlice";

import { fetchtaxesData } from "../../Redux/features/Taxes/taxesSlice";
import SelectDropDownWithCheckBox from "../../reuseableComponents/SelectDropDownWithCheckBox";
import useMultiSelect from "../../hooks/useMultiSelect";
import CheckBoxField from "../../reuseableComponents/CheckBoxField";

import AccessDeniedTooltip from "../../reuseableComponents/AccessDeniedTooltip";
const EditCategory = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { LoginGetDashBoardRecordJson, userTypeData } = useAuthDetails();
  const [loader, setLoader] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);

  const { handleCoockieExpire, getUnAutherisedTokenMessage, getNetworkError } =
    PasswordShow();
  const { permissions, status } = useSelector((state) => state.permissions);
  const hasEditCategoryPermission =
    (status !== "loading" && permissions.length === 0) ||
    permissions.includes(PERMISSIONS.MENU_EDIT_CATEGORIES);

  const hasDisableCategoriesPermission =
    (status !== "loading" && permissions.length === 0) ||
    permissions.includes(PERMISSIONS.MENU_DISABLE_CATEGORIES);
  const [category, setCategory] = useState({
    collID: "",
    title: "",
    description: "",
    merchant_id: "",
    show_online: "",
    use_point: "",
    earn_point: "",
    lottery: "",
    is_ebt_eligible: 0,
    tax: "",
    image: "",
    delivery: 0,
    pickup: 0,
  });

  const [categoryBannerBackupImage, setCategoryBannerBackupImage] =
    useState("");
  let merchant_id = LoginGetDashBoardRecordJson?.data?.merchant_id;
  const params = useParams();
  const [defaultList, setDefaultList] = useState([]);

  const qcList = useSelector((state) => state.qclist);

  async function fetchData() {
    try {
      const getcategoryData = {
        merchant_id: merchant_id,
        id: params?.categoryCode,
        ...userTypeData,
      };

      const { token, ...dataNew } = getcategoryData;
      const response = await axios.post(BASE_URL + EDIT_CATOGRY_DATA, dataNew, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.data.status === true) {
        // console.log(response.data.result)
        return response.data.result;
      }
    } catch (error) {
      if (error?.status == 401 || error?.response?.status === 401) {
        getUnAutherisedTokenMessage();
        handleCoockieExpire();
      } else if (error?.status == "Network Error") {
        getNetworkError();
      }
    }
  }

  // fetching default categories list from superadmin
  const fetchDefaultCategories = async () => {
    try {
      let data = {
        merchant_id: merchant_id,
        token_id: userTypeData?.token_id,
        login_type: userTypeData?.login_type,
        session_id: userTypeData?.session_id || "",
      };
      const response = await axios.post(BASE_URL + LIST_ALL_Defaults, data, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${userTypeData?.token}`,
        },
      });

      if (response.data.status === "Success") {
        // setDefaultList((prev) => [...prev, ...response.data.result]);
        return response.data.result;
      } else if (
        response.data.status === "Failed" &&
        response.data.msg === "No. Data found."
      ) {
        setDefaultList([]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    // qc list api
    if (userTypeData?.token) {
      dispatch(
        fetchQCList({
          merchant_id,
          ...userTypeData,
        }),
      );
    }
  }, []);

  const [currentCategory, setCurrentCategory] = useState(null);

  useEffect(() => {
    const fetchSelectedCategory = async () => {
      try {
        setDataLoading(true);
        const res = await fetchData();

        if (res && res[0]) {
          const cat = res[0];
          setCategory({
            collID: cat.id,
            title: cat.title,
            description: cat.description,
            merchant_id: cat.merchant_id,
            show_online: cat.show_online === "1" ? 1 : 0,
            lottery: cat.is_lottery === "1" ? 1 : 0,
            use_point: cat.use_point === "1" ? 1 : 0,
            earn_point: cat.earn_point === "1" ? 1 : 0,
            is_ebt_eligible: cat.is_ebt_eligible === "1" ? 1 : 0,
            tax: cat.tax,
            image: cat.categoryBanner,
            cat_show_status: cat.cat_show_status,

            // 0-both 1-pick 2-del 3-not both
            delivery:
              cat.method_visibility !== null &&
              (+cat.method_visibility === 0 || +cat.method_visibility === 2)
                ? 1
                : 0,
            pickup:
              cat.method_visibility !== null &&
              (+cat.method_visibility === 0 || +cat.method_visibility === 1)
                ? 1
                : 0,
          });
          setCategoryBannerBackupImage(cat.categoryBanner);

          setCurrentCategory({
            name: cat.title,
            id: cat.id,
          });
        } else {
          setCategoryBannerBackupImage("");
        }
      } catch (err) {
        console.log(err);
      } finally {
        setDataLoading(false);
      }
    };

    if (params.categoryCode) {
      fetchSelectedCategory();
    }
  }, [params.categoryCode]);

  useEffect(() => {
    const fetchAndSetDefaults = async () => {
      try {
        const categoryDefaults = await fetchDefaultCategories();

        const qcDefaults = qcList.qcList
          .filter(
            (item) => item.type === "Category" && item.show_dropdown === "1",
          )
          .map((item) => ({
            name: item.name,
            id: item.id,
          }));

        const normalizedCategoryDefaults = categoryDefaults.map((cat) => ({
          name: cat.name,
          id: cat.id,
        }));

        // Combine all sources
        const combined = [
          ...(currentCategory ? [currentCategory] : []),
          ...normalizedCategoryDefaults,
          ...qcDefaults,
        ];

        // Deduplicate by name
        const seenNames = new Set();
        const uniqueDefaults = combined.filter((item) => {
          if (!item.name || seenNames.has(item.name.trim().toLowerCase())) {
            return false;
          }
          seenNames.add(item.name.trim().toLowerCase());
          return true;
        });

        // console.log("uniqueDefaults: ", uniqueDefaults);
        setDefaultList(uniqueDefaults);
      } catch (err) {
        console.log(err);
      }
    };

    // Wait until qcList is ready and currentCategory is available
    if (qcList?.qcList?.length > 0 && currentCategory) {
      fetchAndSetDefaults();
    }
  }, [qcList, currentCategory]);

  const inputChange = (e) => {
    const { name, value } = e.target;
    const regex = /^[A-Za-z0-9 ]*$/;
    // console.log("name: ", name, value);

    if (name === "title") {
      if (regex.test(value)) {
        // setCategory({ ...category, title: value?.name, collID: value?.id });
        setCategory({ ...category, title: value });
      }
    } else {
      setCategory((preValue) => {
        return {
          ...preValue,
          [name]: value,
        };
      });
    }
  };

  const [selectedImage, setSelectedImage] = useState(null);
  const [alertModalOpen, setAlertModalOpen] = useState(false);
  const [alertModalHeaderText, setAlertModalHeaderText] = useState("");

  const showModal = (headerText) => {
    setAlertModalHeaderText(headerText);
    setAlertModalOpen(true);
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const allowedExtensions = /(\.jpg|\.jpeg|\.png)$/i;
      if (!allowedExtensions.exec(file.name)) {
        showModal("Only jpeg, png, jpg files can be uploaded");
      } else {
        const reader = new FileReader();
        reader.onloadend = () => {
          setSelectedImage(reader.result);
          setCategory((prevValue) => ({
            ...prevValue,
            image: {
              file: file,
              base64: reader.result,
            },
          }));
        };
        reader.readAsDataURL(file);
      }
    }
  };

  // For taxes list start 
  const [alltaxes, setalltaxes] = useState([]);
  const AlltaxesDataState = useSelector((state) => state.taxes);

  useEffect(() => {
    getfetchtaxesDataData();
  }, []);

  const getfetchtaxesDataData = async () => {
    try {
      let data = {
        merchant_id: merchant_id,
        ...userTypeData,
      };
      if (data) {
        await dispatch(fetchtaxesData(data)).unwrap();
      }
    } catch (error) {
      if (error?.status == 401 || error?.response?.status === 401) {
        getUnAutherisedTokenMessage();
        handleCoockieExpire();
      } else if (error?.status == "Network Error") {
        getNetworkError();
      }
    }
  };

  useEffect(() => {
    if (!AlltaxesDataState.loading && AlltaxesDataState.taxesData) {
      // console.log("AlltaxesDataState.taxesData: ", AlltaxesDataState.taxesData);
      setalltaxes(AlltaxesDataState.taxesData);
    }
  }, [
    AlltaxesDataState,
    AlltaxesDataState.loading,
    AlltaxesDataState.taxesData,
  ]);

  const isAllSelected = false;
  const {
    selectedItems: selectedTaxes,
    allOptionSelected: allTaxesSelected,
    handleOptionClick: handleTaxOptionClick,
    setSelectedItems: setSelectedTaxes,
    setAllOptionSelected: setAllTaxesSelected,
    } = useMultiSelect(
    
    alltaxes,
    undefined,
    undefined,
    undefined,
    undefined,
    isAllSelected,
  );
  // For taxes list End 

  // Pre-select taxes coming from API (category.tax is a comma-separated ids string like "2265,4511")
  useEffect(() => {
    if (!alltaxes.length || !category.tax) return;

    const taxIds = category.tax
      .split(",")
      .map((id) => id.trim())
      .filter(Boolean);

    if (!taxIds.length) return;

    const preSelectedTaxes = alltaxes.filter((tax) =>
      taxIds.includes(String(tax.id)),
    );

    if (preSelectedTaxes.length) {
      setSelectedTaxes(preSelectedTaxes);
      setAllTaxesSelected(
        preSelectedTaxes.length === alltaxes.length && alltaxes.length > 1,
      );
    }
  }, [alltaxes, category.tax, setSelectedTaxes, setAllTaxesSelected]);

  // When Lottery is checked, clear all selected taxes
  useEffect(() => {
    if (category.lottery === 1) {
      setSelectedTaxes([]);
      setAllTaxesSelected(false);
    }
  }, [category.lottery, setSelectedTaxes, setAllTaxesSelected]);


  const handleSubmit = async (e) => {
    e.preventDefault();

    let status =
      category.cat_show_status === "0" || category.cat_show_status === "1"
        ? "1"
        : "0";

    if (category.lottery === 1) {
      if (category.cat_show_status === "0") {
        status = "2";
      } else if (category.cat_show_status === "1") {
        status = "3";
      } else if (category.cat_show_status === "2") {
        status = "2";
      } else if (category.cat_show_status === "3") {
        status = "3";
      }
    } else {
      status = category.cat_show_status;
    }
    const formData = new FormData();
    formData.append("collID", category.collID);
    formData.append("title", category.title);
    formData.append(
      "description",
      !!category?.description ? category?.description : "",
    );
    formData.append("merchant_id", category.merchant_id);
    formData.append("show_online", category.show_online);
    formData.append("use_point", category.use_point);
    formData.append("is_lottery", category.lottery ? category.lottery : 0);
    formData.append("earn_point", category.earn_point);
    formData.append("is_ebt_eligible", category.is_ebt_eligible);
    // formData.append("tax", selectedTaxes.map((t) => t.id).join(",") || "");
    // formData.append("tax", category.lottery === 1 ? "" : selectedTaxes.map((t) => t.id).join(",") || "");
    formData.append(
      "tax",
      category.lottery === 1
        ? ""
        : (selectedTaxes || []).map((t) => t.id).join(",") || "",
    );

    // 0-both 1-pick 2-del 3-not both
    const delivery = Number(category?.delivery) === 1;
    const pickup = Number(category?.pickup) === 1;

    const method_visibility =
      delivery && pickup ? 0 : delivery ? 2 : pickup ? 1 : 3;
    formData.append("method_visibility", method_visibility);

    formData.append("token_id", userTypeData?.token_id);
    formData.append("login_type", userTypeData?.login_type);
    formData.append("session_id", userTypeData?.session_id || "");
    formData.append(
      "login_employee_id",
      LoginGetDashBoardRecordJson?.employee_id
        ? LoginGetDashBoardRecordJson?.employee_id
        : null,
    );
    if (category.image && category.image.base64) {
      formData.append("image", category.image.base64);
      formData.append("filename", category.image.file.name);
    } else {
      if (category?.image) {
        formData.append("image", "");
        formData.append("filename", "");
      }
      // else {
      //   setImgErrorMessage("Category Banner Image is required");
      //   return;
      // }
    }
    formData.append("cat_show_status", status);

    // for (let key of formData) {
    //   console.log("key: ", key, formData[key]);
    // }

    setLoader(true);

    try {
      const res = await axios.post(BASE_URL + UPDATE_CATOGRY, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${userTypeData?.token}`,
        },
      });

      const data = await res.data.status;
      const update_message = await res.data.update_message;
      if (data == "Success") {
        // alert(update_message);
        ToastifyAlert("Updated Successfully", "success");
        setErrorMessage(" ");
        setImgErrorMessage("");
        let data = {
          merchant_id: merchant_id,
        };
        setSelectedImage(null);
        navigate("/inventory/category");
      } else if (data == "Failed" && update_message == "*Please enter title") {
        setErrorMessage(update_message);
      } else if (
        data == "Failed" &&
        update_message == "Category Title Already Exist!"
      ) {
        setErrorMessage(update_message);
      } else if (
        data == "Failed" &&
        update_message == "Category ID Not Found"
      ) {
        setErrorMessage(update_message);
      } else if (data == "Failed" && update_message == "Category Not Found") {
        setErrorMessage(update_message);
      }
    } catch (error) {
      if (error?.status == 401 || error?.response?.status === 401) {
        getUnAutherisedTokenMessage();
        handleCoockieExpire();
      } else if (error?.status == "Network Error") {
        getNetworkError();
      }
    }
    setLoader(false);
  };

  const handleSubmitWithPermission = (e) => {
    if (!hasEditCategoryPermission) {
      e.preventDefault();
      return;
    }
    handleSubmit(e);
  };

  const [errorMessage, setErrorMessage] = useState("");
  const [imgErrorMessage, setImgErrorMessage] = useState("");
  const myStyles = {
    display: "flex",
  };

  const [deleteCategoryId, setDeleteCategoryId] = useState(null);
  const [deleteCategoryIMG, setDeleteCategoryIMG] = useState(null);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [deleteloading, setDeleteloading] = useState(false);

  const handleRemoveBanner = (event, id, removeitem) => {
    event.stopPropagation();
    setDeleteCategoryId(id);
    setDeleteCategoryIMG(removeitem);
    setDeleteModalOpen(true);
  };

  const confirmDeleteCategory = async (event) => {
    if (deleteCategoryId) {
      const data = {
        id: deleteCategoryId,
        merchant_id,
        removeitem: deleteCategoryIMG,
        ...userTypeData,
      };
      if (data) {
        try {
          setDeleteloading(true);
          await dispatch(deleteCategorybanner(data)).unwrap();
        } catch (error) {
          if (error?.status == 401 || error?.response?.status === 401) {
            getUnAutherisedTokenMessage();
            handleCoockieExpire();
          } else if (error?.status == "Network Error") {
            getNetworkError();
          }
        }
        ToastifyAlert("Category Image Deleted", "success");
        setSelectedImage(null);
        setCategory((prevValue) => ({
          ...prevValue,
          image: "",
        }));
        setCategoryBannerBackupImage("");
      } else {
        event.preventDefault();
        setCategory((prevValue) => ({
          ...prevValue,
          image: category.image,
        }));
        // console.log("Deletion canceled by user");
      }
    }
    setDeleteloading(false);
    setDeleteCategoryId(null);
    setDeleteCategoryIMG(null);
    setDeleteModalOpen(false);
  };

  // Function to prevent default behavior for drag over
  const inputRef = useRef(null);

  const openFileInput = () => {
    inputRef.current.click();
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  // Function to handle image drop
  const handleDrop = (event) => {
    event.preventDefault();
    const file = event.dataTransfer.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setSelectedImage(reader.result);
        setCategory((prevValue) => ({
          ...prevValue,
          image: {
            file: file,
            base64: reader.result,
          },
        }));
      };
      reader.readAsDataURL(file);
    }
  };

  const handleDeleteImage = (e) => {
    const fileInput = document.getElementById("filesBanner");
    if (fileInput) {
      fileInput.value = "";
    }
    e.stopPropagation();
    setCategory((prevValue) => ({
      ...prevValue,
      image: {
        file: null,
        base64: null,
      },
    }));
  };

  const back = () => {
    navigate("/inventory/category");
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault(); // Prevent default Enter key behavior if necessary
      // Additional logic to handle the Enter key press
    }
  };

  const handleKeyPress = (event) => {
    const allowedChars = /^[a-zA-Z0-9\s]$/;
    if (!allowedChars.test(event.key)) {
      event.preventDefault();
    }
  };

  return (
    <div className="q-category-main-page">
      <div className="box">
        <div className="q-add-categories-section  mt-5">
          <form>
            <SwitchToBackButton
              linkTo={"/inventory/category"}
              title={"Edit Category"}
            />
            <Grid 
            container
              sx={{ display: "block", px: { xs: 1, sm: 2.5 } }}
              className="q-add-categories-section-middle-form"
            >
              <div className="q-add-categories-single-input">
                <label for="title">Category Name</label>
              </div>

              <Autocomplete
                id="size-small-standard"
                size="small"
                options={defaultList}
                freeSolo
                sx={{ margin: "5px 0px 15px 0px" }}
                getOptionLabel={(option) => {
                  // Check if the option is an object with a name property
                  if (typeof option === "object" && option.name) {
                    return option.name;
                  }
                  // Handle other types of options, e.g., strings
                  return typeof option === "string" ? option : "";
                }}
                value={category.title}
                onChange={(event, newValue) => {
                  // console.log("new value: ", newValue);
                  setCategory((previousValue) => ({
                    ...previousValue,
                    title: newValue?.name || "",
                    // collID: newValue?.id,
                  }));
                }}
                disabled={
                  category.title.toLowerCase() === "quickadd" ? true : false
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    className="suggestlist_input MuiAutocomplete-option"
                    name="title"
                    value={category.title}
                    onChange={inputChange}
                    onKeyDown={handleKeyDown}
                    onKeyPress={handleKeyPress}
                    inputProps={{
                      ...params.inputProps,
                      inputMode: "text", // This sets the input mode for text input
                      autoCapitalize: "words", // This enables capitalizing the first letter of each word
                      maxLength: 50, // Limit input to 50 characters
                    }}
                  />
                )}
              />
              {errorMessage && (
                <span className="error-message" style={{ color: "var(--qv-tx-ff0000, red)" }}>
                  {errorMessage}
                </span>
              )}

              <div className="q-add-categories-single-input">
                <label for="description">Description</label>
                <textarea
                  id="description"
                  name="description"
                  rows="4"
                  cols="50"
                  value={!!category?.description ? category?.description : ""}
                  onChange={inputChange}
                ></textarea>
              </div>

              <div className="add-category-checkmark-div">
                <div className="flex gap-4 mb-3 justify-start flex-wrap gap-y-2">
                  {/* cat_show_status =  0 - both on Online & Register, 1- online, 2 - register, 3 - both off => disable if both are off */}
                  <AccessDeniedTooltip
                    hasPermission={hasDisableCategoriesPermission}
                  >
                    <label
                      className={` ${+category.cat_show_status === 2 ||
                        +category.cat_show_status === 3 || +category.lottery === 1
                        ? "add-category-checkmark-label mt-2 ondisabled-check category-checkmark-label cursor-not-allowed"
                        : "add-category-checkmark-label mt-2 category-checkmark-label"
                        } whitespace-nowrap !pt-[1px]`}
                    >
                      <span className="category-text-label">Delivery</span>
                      <CheckBoxField
                        checked={category.delivery === 1}
                        onChangeFun={(e) => {
                          if (hasDisableCategoriesPermission) {
                            setCategory(e);
                          }
                        }}
                        categoryType={"delivery"}
                        isDisabled={
                          +category.cat_show_status === 2 ||
                          +category.cat_show_status === 3 || +category.lottery === 1
                        }
                        style={{ top: "3px" }}
                      />
                    </label>
                  </AccessDeniedTooltip>
                  <AccessDeniedTooltip
                    hasPermission={hasDisableCategoriesPermission}
                  >
                    <label
                      className={` ${+category.cat_show_status === 2 ||
                        +category.cat_show_status === 3 || +category.lottery === 1
                        ? "add-category-checkmark-label mt-2 ondisabled-check category-checkmark-label cursor-not-allowed"
                        : "add-category-checkmark-label mt-2 category-checkmark-label"
                        } whitespace-nowrap !pt-[1px]`}
                    >
                      <span className="category-text-label">Pickup</span>
                      <CheckBoxField
                        checked={category.pickup === 1}
                        onChangeFun={(e) => {
                          if (hasDisableCategoriesPermission) {
                            setCategory(e);
                          }
                        }}
                        categoryType={"pickup"}
                        isDisabled={
                          +category.cat_show_status === 2 ||
                          +category.cat_show_status === 3 || +category.lottery === 1
                        }
                        style={{ top: "3px" }}
                      />
                    </label>
                  </AccessDeniedTooltip>
                </div>
              </div>

              <Grid item xs={4}>
                <label
                  className="q-details-page-label"
                  htmlFor="orderTypeFilter"
                >
                  Taxes
                </label>
                <SelectDropDownWithCheckBox
                  className="mt-1"
                  options={alltaxes}
                  title="title"
                  label={"Select Taxes"}
                  onClickHandler={handleTaxOptionClick}
                  selectedOption={selectedTaxes}
                  allOptionSelected={allTaxesSelected}
                  disabled={category.lottery === 1 ? true : false}
              />
              </Grid>

              {/* <div
                className={`h-[100px] flex items-center justify-center border-2 border-dashed border-[#BFBFBF] bg-white rounded-lg mt-2 defaultDrag_div ${category.lottery === 1 ? "opacity-50 cursor-not-allowed" : "cursor-pointer"}`}
                onDragOver={category.lottery === 1 ? undefined : handleDragOver}
                onDrop={category.lottery === 1 ? undefined : handleDrop}
                onClick={category.lottery === 1 ? undefined : openFileInput}
                style={{
                  cursor: "pointer",
                  position: "relative",
                  height: "auto",
                  padding: "10px",
                  height: "260px",
                  backgroundColor: "#f9f9f9",
                  overflow: "hidden",
                }}
              >
                {category.image && category.image.base64 ? (
                  <>
                    <span
                      className="delete-image-icon img-DeleteIcon"
                      onClick={handleDeleteImage}
                      style={{
                        position: "absolute",
                        top: "7px",
                        right: "7px",
                      }}
                    >
                      <img src={DeleteIcon} alt="delete-icon" />
                    </span>

                    <img
                      src={
                        category.lottery === 1 && categoryBannerBackupImage
                          ? `${BUCKET_BASE_URL}upload/banner/category_banners/${category.merchant_id}/${categoryBannerBackupImage}`
                          : category.image.base64
                      }
                      alt="Preview"
                      className="default-img"
                      style={{
                        height: "320px",
                        objectFit: "contain",
                        width: "100%",
                      }}
                    />
                  </>
                ) : (
                  <>
                    {category.image && category.image.length > 0 ? (
                      <>
                        <img
                          src={`${BUCKET_BASE_URL}upload/banner/category_banners/${category.merchant_id}/${category.image}`}
                          alt="Default"
                          className="default-img"
                          style={{
                            // height: "320px",
                            // objectFit: "contain",
                            // width: "100%",
                            height: "inherit",
                            objectFit: "cover",
                            width: "inherit",
                          }}
                        />
                        {category.lottery === 0 && (
                          <span
                            className="delete-image-icon img-DeleteIcon"
                            // onClick={handleDeleteImage}
                            onClick={(event) =>
                              handleRemoveBanner(
                                event,
                                category.collID,
                                category.image
                              )
                            }
                            style={{
                              position: "absolute",
                              top: "7px",
                              right: "7px",
                            }}
                          >
                            <img src={DeleteIcon} alt="delete-icon" />
                          </span>
                        )}
                      </>
                    ) : (
                      // <div className="flex-column">
                      //   <img
                      //     src={Upload}
                      //     style={{
                      //       transform: "translate(2.5rem, 0px)",
                      //       height: "inherit",
                      //       objectFit: "cover",
                      //       width: "inherit",
                      //     }}
                      //     alt="Default"
                      //   />
                      //   <span>Banner Image for Online Store Categories</span>
                      // </div>

                      <div>
                        <div className="flex justify-center">
                          <img
                            src={Upload}
                            style={{
                              height: "inherit",
                              objectFit: "cover",
                              width: "inherit",
                            }}
                            alt="Default"
                          />
                        </div>
                        <div>
                          <p style={{ color: "#6A6A6A" }}>
                            Banner Image for Online Store Categories
                          </p>
                        </div>
                      </div>
                    )}
                  </>
                )}
                <div className="q-add-categories-single-input">
                  <input
                    type="file"
                    id="filesBanner"
                    name="image"
                    accept="image/*"
                    ref={inputRef}
                    className="default-img-inputfield"
                    onChange={handleImageChange}
                    disabled={category.lottery === 1}
                    style={{ display: "none" }}
                  />
                </div>
              </div>
              {imgErrorMessage && (
                <span className="error-message" style={{ color: "var(--qv-tx-ff0000, red)" }}>
                  {imgErrorMessage}
                </span>
              )} */}
              <div
                className="flex gap-4 flex-wrap mt-3"
                id="disable-permission-edit category"
                style={myStyles}
              >
                {/* {renderRemoveBannerButton()} */}
                {/* <div className="add-category-checkmark-div w-full">
                  <label
                    className={
                      category.lottery === 1
                        ? "add-category-checkmark-label mt-2 ondisabled-check category-checkmark-label"
                        : "add-category-checkmark-label mt-2 category-checkmark-label"
                    }
                  >
                    <span className="category-text-label">Show Banner Online</span>
                    <span className="display-text-apply">
                      Enable this to display a banner in this category on your
                      online store.
                    </span>
                    <input
                      type="checkbox"
                      checked={category.show_online === 1}
                      onChange={(e) => {
                        if (
                          !permissions.length ||
                          permissions.indexOf(
                            PERMISSIONS.MENU_DISABLE_CATEGORIES
                          ) > -1
                        ) {
                          setCategory((prevValue) => ({
                            ...prevValue,
                            show_online: e.target.checked ? 1 : 0,
                          }));
                        } else {
                          e.stopPropagation();
                        }
                      }}
                      disabled={category.lottery === 1}
                      className={
                        category.lottery === 1 ? "ondisabled-check" : ""
                      }
                    />
                    <span
                      className="add-category-checkmark"
                      style={{ top: "3px" }}
                    ></span>
                  </label>
                </div> */}
                <div className="add-category-checkmark-div w-full">
                  <label
                    className={
                      category.lottery === 1
                        ? "add-category-checkmark-label mt-2 ondisabled-check category-checkmark-label"
                        : "add-category-checkmark-label mt-2 category-checkmark-label"
                    }
                  >
                    <AccessDeniedTooltip
                      hasPermission={hasDisableCategoriesPermission}
                    >
                      <span className="category-text-label">Use Points</span>
                    </AccessDeniedTooltip>
                    <span className="display-text-apply">
                      Allow customers to redeem loyalty points for products in
                      this category.
                    </span>
                    <input
                      type="checkbox"
                      checked={category.use_point === 1}
                      onChange={(e) => {
                        if (hasDisableCategoriesPermission) {
                          setCategory((prevValue) => ({
                            ...prevValue,
                            use_point: e.target.checked ? 1 : 0,
                          }));
                        } else {
                          e.stopPropagation();
                        }
                      }}
                      disabled={category.lottery === 1}
                      className={
                        category.lottery === 1 ? "ondisabled-check" : ""
                      }
                    />
                    <span
                      className="add-category-checkmark"
                      style={{ top: "3px" }}
                    ></span>
                  </label>
                </div>
                <div className="add-category-checkmark-div w-full">
                  <label
                    className={
                      category.lottery === 1
                        ? "add-category-checkmark-label mt-2 ondisabled-check category-checkmark-label"
                        : "add-category-checkmark-label mt-2 category-checkmark-label"
                    }
                  >
                    <AccessDeniedTooltip
                      hasPermission={hasDisableCategoriesPermission}
                    >
                      <span className="category-text-label">Earn Points</span>
                    </AccessDeniedTooltip>
                    <span className="display-text-apply">
                      Enable this to let customers earn loyalty points for
                      purchasing products in this category.
                    </span>
                    <input
                      type="checkbox"
                      checked={category.earn_point === 1}
                      onChange={(e) => {
                        if (
                          hasDisableCategoriesPermission
                        ) {
                          setCategory((prevValue) => ({
                            ...prevValue,
                            earn_point: e.target.checked ? 1 : 0,
                          }));
                        } else {
                          e.stopPropagation();
                        }
                      }}
                      disabled={category.lottery === 1}
                      className={
                        category.lottery === 1 ? "ondisabled-check" : ""
                      }
                    />
                    <span
                      className="add-category-checkmark"
                      style={{ top: "3px" }}
                    ></span>
                  </label>
                </div>

                <div className="add-category-checkmark-div">
                  <label className="add-category-checkmark-label mt-2">
                    <AccessDeniedTooltip
                      hasPermission={hasDisableCategoriesPermission}
                    >
                      <span className="category-text-label">Lottery</span>
                    </AccessDeniedTooltip>
                    <input
                      type="checkbox"
                      checked={category.lottery === 1}
                      onChange={(e) => {
                        const { checked } = e.target.value;
                        if (
                          hasDisableCategoriesPermission
                        ) {
                          setCategory((prevValue) => ({
                            ...prevValue,
                            ["show_online"]: 0,
                            ["earn_point"]: 0,
                            ["use_point"]: 0,
                            ["is_ebt_eligible"]: 0,
                            ["delivery"]: 0,
                            ["pickup"]: 0,
                            lottery: e.target.checked ? 1 : 0,
                            image:
                              e.target.checked &&
                              categoryBannerBackupImage === ""
                                ? {
                                    file: null,
                                    base64: null,
                                  }
                                : categoryBannerBackupImage,
                          }));
                          // if (
                          //   e.target.checked &&
                          //   categoryBannerBackupImage === ""
                          // ) {
                          //   const fileInput =
                          //     document.getElementById("filesBanner");
                          //   if (fileInput) {
                          //     fileInput.value = "";
                          //   }
                          // }
                          const fileInput =
                            document.getElementById("filesBanner");
                          if (fileInput) {
                            fileInput.value = "";
                          }
                        } else {
                          e.stopPropagation();
                        }
                      }}
                    />
                    <span className="add-category-checkmark"></span>
                  </label>
                </div>
                <div className="add-category-checkmark-div w-full">
                  <label
                    className={` ${category.lottery === 1
                      ? "add-category-checkmark-label mt-2 ondisabled-check category-checkmark-label"
                      : "add-category-checkmark-label mt-2 category-checkmark-label"
                      } whitespace-nowrap`}
                  >
                    <AccessDeniedTooltip
                      hasPermission={hasDisableCategoriesPermission}
                    >
                      <span className="category-text-label">
                        EBT/SNAP Eligibility
                      </span>
                    </AccessDeniedTooltip>
                    <CheckBoxField
                      checked={category.is_ebt_eligible === 1}
                      onChangeFun={(e) => {
                        if (hasDisableCategoriesPermission) {
                          setCategory(e);
                        }
                      }}
                      categoryType={"is_ebt_eligible"}
                      isDisabled={category.lottery === 1}
                    />
                  </label>
                </div>
              </div>
            </Grid>

            <div className="q-add-categories-section-middle-footer">
              <AccessDeniedTooltip hasPermission={hasEditCategoryPermission}>
                <span>
                  <button
                    className="quic-btn quic-btn-save attributeUpdateBTN"
                    onClick={handleSubmitWithPermission}
                    disabled={loader || dataLoading}
                  >
                    {loader ? (
                      <>
                        <CircularProgress
                          color={"inherit"}
                          className="loaderIcon"
                          width={15}
                          size={15}
                        />{" "}
                        Save
                      </>
                    ) : (
                      "Save"
                    )}
                  </button>
                </span>
              </AccessDeniedTooltip>

              <button className="quic-btn quic-btn-cancle" onClick={back}>
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
      <DeleteModal
        deleteloading={deleteloading}
        headerText="Image"
        open={deleteModalOpen}
        onClose={() => {
          setDeleteModalOpen(false);
        }}
        onConfirm={confirmDeleteCategory}
      />
      <AlertModal
        headerText={alertModalHeaderText}
        open={alertModalOpen}
        onClose={() => {
          setAlertModalOpen(false);
        }}
      />
    </div>
  );
};

export default EditCategory;
